import { ACCENT, illustrationA11y, lineStyle } from './static-art';

/** One drawing, framed per use: each frame keeps the crop and the line weight its original export had. */
const FRAMES = {
	card: { width: 263, height: 195, viewBox: '0 0 263 195', stroke: 0.921875 },
	tight: { width: 109, height: 73, viewBox: '36.3809 42.7055 193.6549 129.6955', stroke: 1.02697 },
} as const;

export function ImpactDistributionIllustration(props: {
	className?: string;
	label?: string;
	ink?: string;
	frame?: keyof typeof FRAMES;
}) {
	const frame = FRAMES[props.frame ?? 'card'];
	const line = lineStyle(props.ink, frame.stroke);
	return (
		<svg
			width={frame.width}
			height={frame.height}
			viewBox={frame.viewBox}
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M169.329 43.3086H93.6705C89.4633 43.3086 86.0527 46.7143 86.0527 50.9155V100.94C86.0527 105.141 89.4633 108.547 93.6705 108.547H169.329C173.536 108.547 176.947 105.141 176.947 100.94V50.9155C176.947 46.7143 173.536 43.3086 169.329 43.3086Z"
				{...line}
			/>
			<path d="M86.0527 49.5078H176.947" {...line} />
			<path
				d="M150.26 60.1168C142.696 54.4053 135.043 61.2787 132.397 64.1127C131.853 64.6948 130.941 64.7256 130.358 64.1845C122.62 57.0315 116.137 58.8858 112.919 60.6683C111.278 61.5762 110.04 63.0457 109.387 64.8C106.678 72.0658 112.534 80.6293 118.616 87.0334L122.35 90.8728C125.73 93.876 129.184 96.3869 130.597 97.3845C131.095 97.7385 131.76 97.7385 132.264 97.3922C150.342 84.8996 160.4 67.7725 150.263 60.1168H150.26Z"
				fill={ACCENT}
			/>
			<path d="M200.198 133.681C188.446 127.279 175.627 113.766 175.627 113.766" {...line} />
			<path d="M193.648 134.979L200.198 133.684L198.567 127.164" {...line} />
			<path d="M65.9375 133.032C77.6903 126.631 90.509 113.117 90.509 113.117" {...line} />
			<path d="M72.4868 134.328L65.9375 133.033L67.5684 126.516" {...line} />
			<path d="M131.569 143.227C131.5 131.801 130.986 115.559 130.986 115.559" {...line} />
			<path d="M136.12 138.352L131.569 143.23L126.879 138.413" {...line} />
			<path
				d="M36.8581 143.629C36.8632 141.177 37.6132 138.776 38.9692 136.732C41.1241 133.49 45.7266 129.238 54.495 131.272C67.4652 134.278 72.2141 152.154 53.5986 155.516C51.8136 155.839 49.9772 155.76 48.2179 155.319C44.0469 154.267 36.8426 151.338 36.8555 143.631L36.8581 143.629Z"
				{...line}
			/>
			<path
				d="M117.03 159.758C117.035 157.306 117.785 154.905 119.141 152.861C121.296 149.619 125.898 145.367 134.667 147.401C147.637 150.407 152.386 168.283 133.771 171.645C131.985 171.968 130.149 171.889 128.39 171.448C124.219 170.396 117.015 167.467 117.027 159.76L117.03 159.758Z"
				{...line}
			/>
			<path
				d="M200.2 143.629C200.205 141.177 200.955 138.776 202.311 136.732C204.466 133.49 209.068 129.238 217.837 131.272C230.807 134.278 235.556 152.154 216.94 155.516C215.155 155.839 213.319 155.76 211.56 155.319C207.389 154.267 200.184 151.338 200.197 143.631L200.2 143.629Z"
				{...line}
			/>
			<path
				d="M51.3979 149.226C51.3979 149.226 46.5977 147.002 44.9359 143.696C42.9223 139.693 48.4777 136.202 51.2952 139.688C51.3286 139.731 51.3645 139.772 51.3979 139.819"
				fill={ACCENT}
			/>
			<path
				d="M51.3965 149.226C51.3965 149.226 56.1967 147.002 57.8585 143.696C59.8721 139.693 54.3167 136.202 51.4992 139.688C51.4658 139.731 51.4299 139.772 51.3965 139.819"
				fill={ACCENT}
			/>
			<path
				d="M131.568 165.351C131.568 165.351 126.768 163.127 125.106 159.821C123.092 155.818 128.648 152.327 131.465 155.813C131.499 155.856 131.534 155.897 131.568 155.944"
				fill={ACCENT}
			/>
			<path
				d="M131.568 165.351C131.568 165.351 136.369 163.127 138.03 159.821C140.044 155.818 134.489 152.327 131.671 155.813C131.638 155.856 131.602 155.897 131.568 155.944"
				fill={ACCENT}
			/>
			<path
				d="M214.738 148.714C214.738 148.714 209.938 146.491 208.276 143.185C206.262 139.181 211.818 135.691 214.635 139.176C214.668 139.22 214.704 139.261 214.738 139.307"
				fill={ACCENT}
			/>
			<path
				d="M214.738 148.714C214.738 148.714 219.539 146.491 221.2 143.185C223.214 139.181 217.658 135.691 214.841 139.176C214.808 139.22 214.772 139.261 214.738 139.307"
				fill={ACCENT}
			/>
		</svg>
	);
}
